"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var nodeTypes = require("../node-type");
var _require = require("../helpers/internal-constants"),
  domSymbolTree = _require.domSymbolTree;
// Serialization only requires a subset of the tree adapter interface.

// Tree traversing
exports.getFirstChild = function (node) {
  return node.firstChild;
};
exports.getChildNodes = function (node) {
  return node.childNodesForSerializing || domSymbolTree.childrenToArray(node);
};
exports.getParentNode = function (node) {
  return node.parentNode;
};
exports.getAttrList = function (element) {
  var attributeList = _toConsumableArray(element._attributeList);
  if (element._isValue && attributeList.every(function (attr) {
    return attr.name !== "is";
  })) {
    attributeList.unshift({
      name: "is",
      namespace: null,
      prefix: null,
      value: element._isValue
    });
  }
  return attributeList;
};

// Node data
exports.getTagName = function (element) {
  return element._qualifiedName;
}; // https://github.com/inikulin/parse5/issues/231

exports.getNamespaceURI = function (element) {
  return element.namespaceURI;
};
exports.getTextNodeContent = exports.getCommentNodeContent = function (node) {
  return node.data;
};
exports.getDocumentTypeNodeName = function (node) {
  return node.name;
};
exports.getDocumentTypeNodePublicId = function (node) {
  return node.publicId;
};
exports.getDocumentTypeNodeSystemId = function (node) {
  return node.systemId;
};
exports.getTemplateContent = function (templateElement) {
  return templateElement._templateContents;
};
exports.getDocumentMode = function (document) {
  return document._mode;
};

// Node types
exports.isTextNode = function (node) {
  return node.nodeType === nodeTypes.TEXT_NODE;
};
exports.isCommentNode = function (node) {
  return node.nodeType === nodeTypes.COMMENT_NODE;
};
exports.isDocumentTypeNode = function (node) {
  return node.nodeType === nodeTypes.DOCUMENT_TYPE_NODE;
};
exports.isElementNode = function (node) {
  return node.nodeType === nodeTypes.ELEMENT_NODE;
};

// Source code location
exports.setNodeSourceCodeLocation = function (node, location) {
  node.sourceCodeLocation = location;
};
exports.getNodeSourceCodeLocation = function (node) {
  return node.sourceCodeLocation;
};
exports.updateNodeSourceCodeLocation = function (node, endLocation) {
  Object.assign(node.sourceCodeLocation, endLocation);
};